import accounting from 'accounting';

function convertNumberFloatToBr(number: string | number): string {
  return accounting.formatMoney(number, '', 2, '.', ',');
}

export default convertNumberFloatToBr;
